import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Header.css'

const Header = () => {
    const location = useLocation();

    const getPageTitle = () => {
        if (location.pathname === "/privacy") return "Privacy Policy";
        if (location.pathname === "/support") return "Support & Contact";
        if (location.pathname === "/terms") return "Terms and conditions";
        return "Home & Gallery";
    };

    return (
        <header>
            <div className='header-section'>
                <Link to={'/'} className='brand-title-link'>
                    <h3 className='text-white brand-title'>Ganpati Wallpaper HD App - {getPageTitle()} </h3>
                </Link>

                <div className='header-items'>
                    <Link to='/' style={{
                        textTransform: "uppercase",
                        fontWeight: `${location.pathname === "/" ? "bold" : "normal"}`
                    }}>
                        Home
                    </Link>
                    <Link to='/terms' style={{
                        textTransform: "uppercase",
                        fontWeight: `${location.pathname === "/terms" ? "bold" : "normal"}`
                    }}>
                        Terms
                    </Link>
                    <Link to='/privacy' style={{
                        textTransform: "uppercase",
                        fontWeight: `${location.pathname === "/privacy" ? "bold" : "normal"}`
                    }} >
                        Privacy Policy
                    </Link>
                    <Link to='/support' style={{
                        textTransform: "uppercase",
                        fontWeight: `${location.pathname === "/support" ? "bold" : "normal"}`
                    }} >
                        Support
                    </Link>
                </div>
            </div>
        </header >
    )
}

export default Header